import { Primitive } from "pytha2";

/**
 * 轴网相关图元
 */
export class AxisNetPrimitive extends Primitive {

    /**
     * 图元类型
     */
    type: string;
    /**
     * 所属的轴网uuid（轴线段用）
     */
    axisNetUuid: string;
    /**
     * 轴网uuid数组（竖向轴线用）
     */
    axisNetUuids: string[];

    constructor(type: string, uuid?: string) {
        super(type, uuid);
        this.type = type;
        if (!!uuid) {
            this.uuid = uuid;
        }
    }

    /**
    * 获取祖先图元
    * 重写：不获取祖先
    * @returns 
    */
    getRootPrimitive?(): Primitive {
        let primitive: Primitive = this;
        return primitive;
    }

    /**
     * 复制图元
     * @param primitive 
     * @returns 
     */
    copy(primitive: AxisNetPrimitive) {
        super.copy(primitive);
        return this;
    }

    /**
     * 克隆图元
     */
    clone() {
        return new AxisNetPrimitive(this.type, this.axisNetUuid).copy(this);
    }

    /**
     * 抽象成json数据格式
     * @returns 
     */
    toJson() {
        let data = super.toJson();
        let res = {
            ...data,
            type: this.type,
            axisNetUuid: this.axisNetUuid,
        }
        return res;
    }


    /**
     * 解析数据成对象
     */
    fromJson(json) {
        super.fromJson(json);
        this.axisNetUuid = json?.axisNetUuid;
        return this;
    }
}